<template>
  <div
    class="gk-chin-card"
    :class="{ 'gk-chin-card--static': isSigned }"
    ref="wrapRef"
    @click="onCardTap"
  >
    <!-- <q-tooltip
      v-if="!isMobile"
      transition-show="flip-right" transition-hide="flip-left"
      class="bg-warning text-dark text-subtitle2"
      :offset="[10, 10]"
      :delay="500"
    >
      <p class="text-center q-mb-none">Чиним! Приносим извинения за неудобство!<br />
      Для экономии времени в поликлинике, пожалуйста, распечатайте и подпишите документ заранее.</p>
    </q-tooltip> -->
    <div class="row items-center no-wrap gk-chin-row">
      <div class="quick-icon-box">
        <!-- <q-icon name="vpn_key" size="26px" class="quick-icon" /> -->
        <svg width="26" height="26" viewBox="0 0 36 36">
          <defs>
            <mask id="key-cutout" maskUnits="userSpaceOnUse" x="0" y="0" width="36" height="36">
              <rect x="0" y="0" width="36" height="36" fill="#ffffff"></rect>
              <rect x="6.33" y="10.71" width="9.71" height="2.57"
              rx="1" ry="1" transform="translate(-5.21 11.43) rotate(-45)" fill="#000000"></rect>
            </mask>
          </defs>
          <g transform="translate(36,0) scale(-1,1)">
            <g mask="url(#key-cutout)">
              <path d="M23.35,16.8l.63-.63A5,5,0,0,0,24,9.1L18.71,3.84a5,5,0,0,0-7.07,
              0L3.09,12.39a5,5,0,0,0,0,7.07l5.26,5.26a5,5,0,0,0,7.07,0l.4-.4L18,
              26.48h3.44v3h3.69v1.63L28,34h6V27.45Z" fill="#2563eb" stroke="#2563eb"
              stroke-width="0.75" stroke-linejoin="round"></path>
            </g>
          </g>
        </svg>
      </div>

      <div class="quick-text">
        <div v-if="status" class="quick-title">
          Статус подписания ГОСКЛЮЧОМ:
          <span :class="statusClass">{{ status.signed_str }}</span>
        </div>
        <div v-else class="quick-title">Подписать ГОСКЛЮЧОМ</div>
        <div v-if="isError" class="quick-subtitle">
          Нажмите, чтобы отправить на подписание повторно
        </div>
      </div>

      <q-spinner v-if="loading" size="20px" class="quick-arrow" />
      <q-icon v-else :name="actionIcon" size="20px" :class="
      ['quick-arrow', { [statusClass]: !isPending }]" />
    </div>

    <!-- <div class="gk-tape" :style="tapeStyle" aria-hidden="true"> -->
      <!-- <span class="gk-tape-text">чиним</span> -->
    <!-- </div> -->
  </div>
</template>

<script setup lang="ts">
import {
  ref, reactive, computed, onMounted, onBeforeUnmount, PropType,
} from 'vue';
import { useQuasar } from 'quasar';
import { GoskluchSignStatus } from '@/store/ecohospital/types';

type UserDocument = {
  att_type: number;
  checksum: number;
  date_doc: string;
  datebegin: string;
  doc_name: string;
  doc_type: number;
  file_ext: string;
  id_document: number;
  id_patient: number;
  is_napravlenie: number;
  goskluch: boolean;
  tg: string;
};

const props = defineProps({
  document: {
    type: Object as () => UserDocument,
  },
  status: {
    type: Object as PropType<GoskluchSignStatus | null>,
    default: null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const $q = useQuasar();
const isMobile = $q.platform.is.mobile;

const emit = defineEmits(['handleSign', 'refreshStatus']);

// -1 — ошибка, 0 — ожидаем подписания, 1 — подписано
const isSigned = computed(() => Number(props.status?.signed) === 1);
const isError = computed(() => Number(props.status?.signed) === -1);
const isPending = computed(() => !!props.status && !isSigned.value && !isError.value);

const statusClass = computed(() => {
  if (isSigned.value) return 'gk-status--signed';
  if (isError.value) return 'gk-status--error';
  if (isPending.value) return 'gk-status--pending';
  return '';
});

const actionIcon = computed(() => {
  if (isSigned.value) return 'check_circle';
  if (isPending.value) return 'refresh';
  return 'open_in_new';
});

const wrapRef = ref<HTMLElement | null>(null);
const tapeStyle = reactive({
  width: '0px',
  left: '0px',
  top: '0px',
  transformOrigin: '0px 50%',
  transform: 'rotate(0deg)',
});

const THICKNESS = 24;
const HALF_T = THICKNESS / 2;

const onCardTap = () => {
  if (props.loading || isSigned.value) return;
  if (isPending.value) {
    emit('refreshStatus');
    return;
  }
  // if (!isMobile) return;
  // $q.notify({
  //   type: 'warning',
  //   message: 'Чиним! Приносим извинения за неудобство!',
  //   caption:
  // 'Для экономии времени в поликлинике, пожалуйста, распечатайте и подпишите документ заранее.',
  //   position: 'top',
  //   timeout: 5000,
  //   multiLine: true,
  // });
  emit('handleSign', props.document);
};

function updateTape() {
  const el = wrapRef.value;
  if (!el) return;
  const w = el.clientWidth;
  const h = el.clientHeight;

  // точки крепления: левый нижний угол → середина правой грани
  const ax = w / 2;
  const ay = h;
  const bx = w;
  const by = h / 2;
  const dx = bx - ax;
  const dy = by - ay;
  const length = Math.sqrt(dx * dx + dy * dy);
  const angle = (Math.atan2(dy, dx) * 180) / Math.PI;

  const overshoot = Math.max(w, h);

  tapeStyle.width = `${length + overshoot * 2}px`;
  tapeStyle.left = `${ax - overshoot}px`;
  tapeStyle.top = `${ay - HALF_T}px`;
  tapeStyle.transformOrigin = `${overshoot}px 50%`;
  tapeStyle.transform = `rotate(${angle}deg)`;
}

let observer: ResizeObserver | null = null;
onMounted(() => {
  updateTape();
  if (wrapRef.value) {
    observer = new ResizeObserver(updateTape);
    observer.observe(wrapRef.value);
  }
});
onBeforeUnmount(() => observer?.disconnect());
</script>

<style scoped>
.gk-chin-card {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0 0 18px 18px;
  background: #ffffff;
  box-shadow: 0 14px 24px rgba(15, 23, 42, 0.12);
  /* cursor:not-allowed; */
  cursor: pointer;
  padding-top: 14px;
}

.gk-chin-row {
  padding: 14px 16px 18px;
}

.quick-icon-box {
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: #eef4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.quick-icon {
  color: #2563eb;
}

.quick-text {
  flex: 1;
  margin-left: 14px;
}

.quick-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}

.quick-arrow {
  color: #2563eb;
}

.quick-subtitle {
  font-size: 13px;
  color: #6b7280;
}

.gk-chin-card--static {
  cursor: default;
}

.gk-status--pending {
  color: #ea580c;
}

.gk-status--signed {
  color: #16a34a;
}

.gk-status--error {
  color: #dc2626;
}

.gk-tape {
  position: absolute;
  height: 24px;
  background: repeating-linear-gradient(45deg, #d32f2f 0 14px, #ffffff 14px 28px);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.gk-tape-text {
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: #000;
}
</style>
